import { useState, useContext, useEffect } from "react";
import {
    fetchedUsersByGang,
    getSalesForChartPieData,
} from "../../../apis/apis.dispatches/apisDispatch";
import { fetchedGangs } from "../../../apis/apis.logistics/apisProduct";
import { getCurrentDate } from "../../../configs/helpers";
import { ContextAuth } from "../../../contexts/ContextAuth";

const inputCls = "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
const labelCls = "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

export function DailyRouteGraphByDayFilter({ setDailyRouteData }) {
    const { auth }  = useContext(ContextAuth);
    const [gangs, setGangs]     = useState([]);
    const [users, setUsers]     = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [questionState, setQuestionState] = useState({
        routeDate:    getCurrentDate("-"),
        subsidiaryID: auth.data.subsidiary.subsidiary_id,
        warehouseID:  0,
        gang:         { gangID: 0, gangName: "" },
        userID:       0,
        customerType: 0,
    });

    const getGangs = async () => {
        try { setGangs(await fetchedGangs()); }
        catch (e) { throw e; }
    };

    const getUsersByGang = async (id) => {
        try { setUsers(await fetchedUsersByGang({ gangID: id })); }
        catch (e) { throw e; }
    };

    const searchSuggestions = async () => {
        setIsLoading(true);
        try {
            const res = await getSalesForChartPieData(questionState);
            res.all_thumbtacks =
                res.redThumbtacks + res.blueThumbtacks + res.yellowThumbtacks +
                res.greenThumbtacks + res.grayThumbtacks + res.skyBlueThumbtacks +
                res.darkGreenThumbtacks + res.fuchsiaThumbtacks;
            setDailyRouteData(res);
        } catch (e) { throw e; }
        finally { setIsLoading(false); }
    };

    function handleChange(e) {
        if (e.target.name === "gangID") {
            const select = document.getElementById("gangID");
            const text   = select.options[select.selectedIndex].text;
            setQuestionState({
                ...questionState,
                gang: { gangID: Number(e.target.value), gangName: text },
                userID: 0,
            });
            getUsersByGang(e.target.value);
        } else {
            setQuestionState({ ...questionState, [e.target.name]: e.target.value });
        }
    }

    useEffect(() => { getGangs(); }, []);

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
            <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                <h2 className="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                    <i className="fas fa-filter text-blue-500"></i>
                    Filtros
                </h2>
            </div>

            <div className="px-5 py-4 space-y-4">

                {/* Ruta */}
                <div>
                    <label htmlFor="gangID" className={labelCls}>
                        <i className="fas fa-route mr-1"></i>Ruta
                    </label>
                    <select
                        id="gangID"
                        name="gangID"
                        value={questionState.gang.gangID}
                        onChange={handleChange}
                        className={inputCls}
                    >
                        <option value={0}>Todas las rutas</option>
                        {gangs.map((item, i) => (
                            <option key={i} value={item.gangID}>{item.gangName}</option>
                        ))}
                    </select>
                </div>

                {/* Usuario */}
                <div>
                    <label className={labelCls}>
                        <i className="fas fa-user mr-1"></i>Usuario
                    </label>
                    <select
                        name="userID"
                        value={questionState.userID}
                        onChange={(e) => setQuestionState({ ...questionState, userID: Number(e.target.value) })}
                        className={inputCls}
                    >
                        <option value={0}>Todos</option>
                        {users.map((item, i) => (
                            <option key={i} value={item.id}>
                                {item.first_name} | {item.last_name}
                            </option>
                        ))}
                    </select>
                </div>

                {/* Fecha */}
                <div>
                    <label htmlFor="routeDate" className={labelCls}>
                        <i className="fas fa-calendar mr-1"></i>Fecha
                    </label>
                    <input
                        type="date"
                        id="routeDate"
                        name="routeDate"
                        value={questionState.routeDate}
                        onChange={handleChange}
                        className={inputCls}
                    />
                </div>

                {/* Buscar */}
                <button
                    id="btn-filter"
                    onClick={searchSuggestions}
                    disabled={isLoading}
                    className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800"
                >
                    {isLoading
                        ? <span className="h-4 w-4 rounded-full border-2 border-white border-t-transparent animate-spin"></span>
                        : <i className="fas fa-search"></i>}
                    {isLoading ? "Buscando..." : "Buscar"}
                </button>
            </div>
        </div>
    );
}
